export default __webpack_public_path__ + "static/media/animatedcomputer.0e13ccb7.jpg";